import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  FinancialPlan = 'FinancialPlan',
  GoalsSummary = 'GoalsSummary',
  BeFi20GoalSummary = 'BeFi20GoalSummary',
  GoalOptions = 'GoalOptions',
  PLDGoalSummary = 'PLDGoalSummary',
  DecumulationGoal = 'DecumulationGoal',
  DecumulationDetails = 'DecumulationDetails',
  PulseCheckCard = 'PulseCheckCard',
  EstatePlanningExplanation = 'EstatePlanningExplanation',
  EstatePlanningExplanationOptions = 'EstatePlanningExplanationOptions',
}

export const queryKeys = {
  financialPlan: (clientId: number, fpId: string, isPdf = false) => [
    QueryFeature.FinancialPlan,
    QueryKey.FinancialPlan,
    clientId,
    fpId,
    isPdf,
  ],

  goalsSummary: (clientId: number, fpId: string) => [
    QueryFeature.FinancialPlan,
    QueryKey.GoalsSummary,
    clientId,
    fpId,
  ],

  beFi20GoalSummary: (clientId: number) => [
    QueryFeature.FinancialPlan,
    QueryKey.BeFi20GoalSummary,
    clientId,
  ],

  goalOptions: (clientId: number, fpId: string) => [
    QueryFeature.FinancialPlan,
    QueryKey.GoalOptions,
    clientId,
    fpId,
  ],

  PLDGoalSummary: (clientId: number, fpId: string) => [
    QueryFeature.FinancialPlan,
    QueryKey.PLDGoalSummary,
    clientId,
    fpId,
  ],

  decumulationGoal: (clientId: number, fpId: string) => [
    QueryFeature.FinancialPlan,
    QueryKey.DecumulationGoal,
    clientId,
    fpId,
  ],

  decumulationDetails: (clientId: number, fpId: string) => [
    QueryFeature.FinancialPlan,
    QueryKey.DecumulationDetails,
    clientId,
    fpId,
  ],

  pulseCheckCard: (clientId: number) => [
    QueryFeature.FinancialPlan,
    QueryKey.PulseCheckCard,
    clientId,
  ],

  estatePlanningExplanation: (clientId: number, fpId: string, isPdf = false) => [
    QueryFeature.FinancialPlan,
    QueryKey.EstatePlanningExplanation,
    clientId,
    fpId,
    isPdf,
  ],

  estatePlanningExplanationOptions: (clientId: number, fpId: string) => [
    QueryFeature.FinancialPlan,
    QueryKey.EstatePlanningExplanationOptions,
    clientId,
    fpId,
  ],
};
